/** Identifiers for optional widget features. Extend this as more
 *  toggleable features are added. */
export enum WidgetFeatureType {
  addFiles = 'isAddFiles',
}
